// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"7b4e0346","385":"f0f4c298","431":"3a8a15f5","672":"ad3611a6","853":"d0130a5f","942":"6d15562a"}[chunkId] + ".chunk.js";
};